import { IconButton, Stack, Tooltip, Typography } from '@mui/material';

type Props = {
  children: string;
  tooltip?: React.ReactNode;
};

export function FieldLabel({ children, tooltip }: Props) {
  return (
    <Stack spacing="6px" direction="row" alignItems="center">
      <Typography
        sx={{
          color: 'var(--Gray-700, #344054)',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: '20px',
        }}
      >
        {children}
      </Typography>

      {tooltip ? (
        <Tooltip title={tooltip} arrow>
          <IconButton sx={{ padding: '4px', width: '18px', height: '18px' }}>
            <i
              className="fa-regular fa-info-circle"
              style={{ fontSize: '14px', color: '#828282' }}
            />
          </IconButton>
        </Tooltip>
      ) : null}
    </Stack>
  );
}
